import { GamePayTableProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GamePayTableProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
import { MiniPayTableCellPortraitProperties } from "./MiniPayTableCellPortraitProperties";
/**
 * MiniPayTablePortraitProperties.ts
 */
export class MiniPayTablePortraitProperties extends GamePayTableProperties {
    constructor() {
        super();
        this.animationProperties = new SpineProperties(GameStyle.MINI_PAY_LADDER, SlingoStyle.MODULE, new Point(512, 325));
        this.animationSkin = "default";
        this.cells = [
            new MiniPayTableCellPortraitProperties(11, new Point(102, cellHeight)), //11
            new MiniPayTableCellPortraitProperties(10, new Point(90, cellHeight)), //10
            new MiniPayTableCellPortraitProperties(9, new Point(90, cellHeight)), //9
            new MiniPayTableCellPortraitProperties(8, new Point(82, cellHeight)), //8
            new MiniPayTableCellPortraitProperties(7, new Point(77, cellHeight)), //7
            new MiniPayTableCellPortraitProperties(6, new Point(70, cellHeight)), //6
            new MiniPayTableCellPortraitProperties(5, new Point(65, cellHeight)), //5
            new MiniPayTableCellPortraitProperties(4, new Point(62, cellHeight)), //4
            new MiniPayTableCellPortraitProperties(3, new Point(60, cellHeight)), //3
            new MiniPayTableCellPortraitProperties(2, new Point(0, cellHeight)), //2
            new MiniPayTableCellPortraitProperties(1, new Point(0, cellHeight)), //1
        ].reverse();
        this.portraitPrimary = true;
        this.backToGameButtonProperties.visible = false;
    }
}
const cellHeight = 80;
//# sourceMappingURL=MiniPayTablePortraitProperties.js.map